// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@2.1.8_@module-federation+runtime-tools@2.8.2__webpack@5.109.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@2.1.8_@module-federation+runtime-tools@2.8.2__webpack@5.109.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-layout.app-root {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
.app-main-content {
  background: white;
}
`, "",{"version":3,"sources":["webpack://./src/app/styles/app.less"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,iBAAA;EACA,sBAAA;AADJ;AAIA;EACI,iBAAA;AAFJ","sourcesContent":["@import '../routes/home/home';\n\n.ant-layout.app-root {\n    display: flex;\n    min-height: 100vh;\n    flex-direction: column;\n}\n\n.app-main-content {\n    background: white;\n}\n\n@root-entry-name: default;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
